import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { deleteBrandCategory } from "../../../api/ApiBrandCategory";

const DeleteView = ({ idItem, onSearch }: DeleteProduct) => {
  const handleDeleteProduct = async () => {
    const res = await deleteBrandCategory(idItem);
    if (res && res.success) {
      modals.closeAll();
      onSearch();
    }
  };

  return (
    <div>
      <Text size="lg">
        Bạn có chắc chắn muốn xóa các hãng bảo hành đã chọn không?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="red"
          onClick={handleDeleteProduct}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: number[];
  onSearch: () => void;
};

export default DeleteView;
